/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DriverPaymentsSummaryList,
    DriverPaymentsSummaryListFromJSON,
    DriverPaymentsSummaryListToJSON,
    PaymentsSummaryList,
    PaymentsSummaryListFromJSON,
    PaymentsSummaryListToJSON,
} from '../models';

export interface SummarizePaymentsByDriverMonthRequest {
    officeId: number;
    month: number;
}

export interface SummarizePaymentsByOfficeRequest {
    officeIds: Array<number>;
    startMonth: number;
    endMonth: number;
    officeId?: number;
}

/**
 * 
 */
export class PaymentsSummaryApi extends runtime.BaseAPI {

    /**
     * 月ごとの乗務員ごとの請求金額サマリ
     */
    async summarizePaymentsByDriverMonthRaw(requestParameters: SummarizePaymentsByDriverMonthRequest): Promise<runtime.ApiResponse<DriverPaymentsSummaryList>> {
        if (requestParameters.officeId === null || requestParameters.officeId === undefined) {
            throw new runtime.RequiredError('officeId','Required parameter requestParameters.officeId was null or undefined when calling summarizePaymentsByDriverMonth.');
        }

        if (requestParameters.month === null || requestParameters.month === undefined) {
            throw new runtime.RequiredError('month','Required parameter requestParameters.month was null or undefined when calling summarizePaymentsByDriverMonth.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/payments_summary/{office_id}/year/{month}`.replace(`{${"office_id"}}`, encodeURIComponent(String(requestParameters.officeId))).replace(`{${"month"}}`, encodeURIComponent(String(requestParameters.month))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DriverPaymentsSummaryListFromJSON(jsonValue));
    }

    /**
     * 月ごとの乗務員ごとの請求金額サマリ
     */
    async summarizePaymentsByDriverMonth(requestParameters: SummarizePaymentsByDriverMonthRequest): Promise<DriverPaymentsSummaryList> {
        const response = await this.summarizePaymentsByDriverMonthRaw(requestParameters);
        return await response.value();
    }

    /**
     * 営業所の請求金額サマリ
     */
    async summarizePaymentsByOfficeRaw(requestParameters: SummarizePaymentsByOfficeRequest): Promise<runtime.ApiResponse<PaymentsSummaryList>> {
        if (requestParameters.officeIds === null || requestParameters.officeIds === undefined) {
            throw new runtime.RequiredError('officeIds','Required parameter requestParameters.officeIds was null or undefined when calling summarizePaymentsByOffice.');
        }

        if (requestParameters.startMonth === null || requestParameters.startMonth === undefined) {
            throw new runtime.RequiredError('startMonth','Required parameter requestParameters.startMonth was null or undefined when calling summarizePaymentsByOffice.');
        }

        if (requestParameters.endMonth === null || requestParameters.endMonth === undefined) {
            throw new runtime.RequiredError('endMonth','Required parameter requestParameters.endMonth was null or undefined when calling summarizePaymentsByOffice.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.officeIds) {
            queryParameters['office_ids'] = requestParameters.officeIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.officeId !== undefined) {
            queryParameters['office_id'] = requestParameters.officeId;
        }

        if (requestParameters.startMonth !== undefined) {
            queryParameters['start_month'] = requestParameters.startMonth;
        }

        if (requestParameters.endMonth !== undefined) {
            queryParameters['end_month'] = requestParameters.endMonth;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/payments_summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentsSummaryListFromJSON(jsonValue));
    }

    /**
     * 営業所の請求金額サマリ
     */
    async summarizePaymentsByOffice(requestParameters: SummarizePaymentsByOfficeRequest): Promise<PaymentsSummaryList> {
        const response = await this.summarizePaymentsByOfficeRaw(requestParameters);
        return await response.value();
    }

}
